<template>
  <div>
      <div id='invalid'>
        <svg id="invalid-img" width="80" height="80" stroke-width="1" stroke="currentColor" fill="none" style="color:red">
          <use xlink:href="/static/img/feather-sprite.svg#alert-triangle"/>
        </svg>
        <br>
        <span id="invalid-msg" >
              Go back... wrong way!
        </span>
       </div>

  </div>
</template>

<script>
  export default {
  }

</script>

<style scoped>
  div#invalid {
    height: 10em;
    position: relative;
    font-size: 25px;
  }
  span#invalid-msg{
    margin: 0;
    position: absolute;
    top: 80%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%)
  }
  svg#invalid-img{
    margin: 0;
    position: absolute;
    top: 40%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%)
  }
</style>
